import type { ReactNode } from 'react';
import { createContext } from 'react';

import { setUserInfo } from '../configuration';
import { NewUserInfo, type UserInfo } from '../types/api/UserInfo/UserInfo';

export type SlabContextType = {
  userInfo: UserInfo;
};

export const SlabContext = createContext<SlabContextType>({
  userInfo: NewUserInfo({}),
});

type SlabProviderProps = {
  context: SlabContextType;
  children: ReactNode;
};

export const SlabProvider = ({ context, children }: SlabProviderProps) => {
  // TODO: refactor and instead of SlabContext use store
  setUserInfo(context.userInfo);

  return <SlabContext.Provider value={context}>{children}</SlabContext.Provider>;
};
